import { render, staticRenderFns } from "./treatmentplan.vue?vue&type=template&id=112ae918&"
import script from "./treatmentplan.vue?vue&type=script&lang=js&"
export * from "./treatmentplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports